import React from "react";
import { connect } from "react-redux";
import FinalPayTable from "./components/FinalPayTable";
import DownloadButton from "components/button/download";
import UploadButton from "components/button/upload";

const FinalPays = ({filters}) => {
	
	return (
	    <div>
	      <div className="mt-5 grid h-full grid-cols-1 gap-4">
      		
	      	<FinalPayTable/>

			<div className="flex flex-row-reverse text-right">	      		
				<DownloadButton downloadPath="final-pays" title="Download" filters={filters}/>
				<UploadButton uploadPath="final-pays" title="Upload"/>
			</div>
	      	
	      </div>
	    </div>
    );
};

const mapStateToProps = (state) => ({
  filters: state.finalPay.finalPayList?.filters,
});

const mapDispatchToProps = (dispatch) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(FinalPays);